// Auto-generated from CCP static data via Fuzzwork's trnTranslations.csv.
// Canonical localized names for every PI commodity, used to render
// product labels in zh / ru without depending on a runtime ESI call.
// Regenerate via scripts/generate_translations.py.

export type Locale = "en" | "zh" | "ru";

export const PI_NAMES_ZH: Record<string, string> = {
  "Aqueous Liquids": "水基液体",
  "Autotrophs": "自养生物",
  "Bacteria": "细菌",
  "Base Metals": "基础金属",
  "Biocells": "生物电池",
  "Biofuels": "生物燃料",
  "Biomass": "生物质",
  "Biotech Research Reports": "生物技术研究报告",
  "Broadcast Node": "广播节点",
  "Camera Drones": "监控无人机",
  "Carbon Compounds": "碳化合物",
  "Chiral Structures": "手性结构",
  "Complex Organisms": "复杂有机生命体",
  "Condensates": "凝缩液",
  "Construction Blocks": "建筑模块",
  "Consumer Electronics": "消费级电器",
  "Coolant": "冷却剂",
  "Cryoprotectant Solution": "冷冻保存防腐剂",
  "Data Chips": "数据芯片",
  "Electrolytes": "电解物",
  "Enriched Uranium": "核能燃料",
  "Felsic Magma": "长英矿物岩浆",
  "Fertilizer": "肥料",
  "Gel-Matrix Biopaste": "凝胶基质生物胶",
  "Genetically Enhanced Livestock": "基因肉制品",
  "Guidance Systems": "制导系统",
  "Hazmat Detection Systems": "危险物探测系统",
  "Heavy Metals": "重金属",
  "Hermetic Membranes": "密封薄膜",
  "High-Tech Transmitters": "高科技传信器",
  "Industrial Explosives": "工业炸药",
  "Industrial Fibers": "工业纤维",
  "Integrity Response Drones": "反破损快速反应无人机",
  "Ionic Solutions": "离子溶液",
  "Livestock": "家畜",
  "Mechanical Parts": "机械元件",
  "Microfiber Shielding": "微纤维护盾",
  "Microorganisms": "微生物",
  "Miniature Electronics": "微型电子元件",
  "Nanites": "纳米体",
  "Nano-Factory": "纳米-工厂",
  "Neocoms": "控制面板",
  "Noble Gas": "稀有气体",
  "Noble Metals": "贵金属",
  "Non-CS Crystals": "非立方晶体",
  "Nuclear Reactors": "核反应堆",
  "Organic Mortar Applicators": "有机砂浆喷注器",
  "Oxides": "氧化物",
  "Oxidizing Compound": "氧化剂",
  "Oxygen": "氧",
  "Planetary Vehicles": "大气内穿梭机",
  "Planktic Colonies": "浮游生物群",
  "Plasmoids": "等离子体团",
  "Polyaramids": "聚芳酰胺",
  "Polytextiles": "合成纺织品",
  "Precious Metals": "稀有金属",
  "Proteins": "蛋白质",
  "Reactive Gas": "活性气体",
  "Reactive Metals": "反应金属",
  "Recursive Computing Module": "递推计算模块",
  "Robotics": "机器人技术",
  "Rocket Fuel": "火箭燃料",
  "Self-Harmonizing Power Core": "自协调能源核心",
  "Silicate Glass": "硅酸盐玻璃",
  "Silicon": "硅",
  "Smartfab Units": "灵巧单元建筑模块",
  "Sterile Conduits": "无菌管道",
  "Supercomputers": "超级计算机",
  "Superconductors": "超导体",
  "Supertensile Plastics": "超张力塑料",
  "Suspended Plasma": "悬浮等离子",
  "Synthetic Oil": "合成油",
  "Synthetic Synapses": "合成神经键",
  "Test Cultures": "培养基",
  "Toxic Metals": "有毒金属",
  "Transcranial Microcontrollers": "透颅微控器",
  "Transmitter": "传信器",
  "Ukomi Superconductors": "乌克米超导体",
  "Vaccines": "疫苗",
  "Viral Agent": "病原体",
  "Water": "水",
  "Water-Cooled CPU": "水冷CPU",
  "Wetware Mainframe": "湿件主机",
};

export const PI_NAMES_RU: Record<string, string> = {
  "Aqueous Liquids": "Aqueous Liquids",
  "Autotrophs": "Autotrophs",
  "Bacteria": "Bacteria",
  "Base Metals": "Base Metals",
  "Biocells": "Biocells",
  "Biofuels": "Biofuels",
  "Biomass": "Biomass",
  "Biotech Research Reports": "Biotech Research Reports",
  "Broadcast Node": "Broadcast Node",
  "Camera Drones": "Camera Drones",
  "Carbon Compounds": "Carbon Compounds",
  "Chiral Structures": "Chiral Structures",
  "Complex Organisms": "Complex Organisms",
  "Condensates": "Condensates",
  "Construction Blocks": "Construction Blocks",
  "Consumer Electronics": "Consumer Electronics",
  "Coolant": "Coolant",
  "Cryoprotectant Solution": "Cryoprotectant Solution",
  "Data Chips": "Data Chips",
  "Electrolytes": "Electrolytes",
  "Enriched Uranium": "Enriched Uranium",
  "Felsic Magma": "Felsic Magma",
  "Fertilizer": "Fertilizer",
  "Gel-Matrix Biopaste": "Gel-Matrix Biopaste",
  "Genetically Enhanced Livestock": "Genetically Enhanced Livestock",
  "Guidance Systems": "Guidance Systems",
  "Hazmat Detection Systems": "Hazmat Detection Systems",
  "Heavy Metals": "Heavy Metals",
  "Hermetic Membranes": "Hermetic Membranes",
  "High-Tech Transmitters": "High-Tech Transmitters",
  "Industrial Explosives": "Industrial Explosives",
  "Industrial Fibers": "Industrial Fibers",
  "Integrity Response Drones": "Integrity Response Drones",
  "Ionic Solutions": "Ionic Solutions",
  "Livestock": "Livestock",
  "Mechanical Parts": "Mechanical Parts",
  "Microfiber Shielding": "Microfiber Shielding",
  "Microorganisms": "Microorganisms",
  "Miniature Electronics": "Miniature Electronics",
  "Nanites": "Nanites",
  "Nano-Factory": "Nano-Factory",
  "Neocoms": "Neocoms",
  "Noble Gas": "Noble Gas",
  "Noble Metals": "Noble Metals",
  "Non-CS Crystals": "Non-CS Crystals",
  "Nuclear Reactors": "Nuclear Reactors",
  "Organic Mortar Applicators": "Organic Mortar Applicators",
  "Oxides": "Oxides",
  "Oxidizing Compound": "Oxidizing Compound",
  "Oxygen": "Oxygen",
  "Planetary Vehicles": "Planetary Vehicles",
  "Planktic Colonies": "Planktic Colonies",
  "Plasmoids": "Plasmoids",
  "Polyaramids": "Polyaramids",
  "Polytextiles": "Polytextiles",
  "Precious Metals": "Precious Metals",
  "Proteins": "Proteins",
  "Reactive Gas": "Reactive Gas",
  "Reactive Metals": "Reactive Metals",
  "Recursive Computing Module": "Recursive Computing Module",
  "Robotics": "Robotics",
  "Rocket Fuel": "Rocket Fuel",
  "Self-Harmonizing Power Core": "Self-Harmonizing Power Core",
  "Silicate Glass": "Silicate Glass",
  "Silicon": "Silicon",
  "Smartfab Units": "Smartfab Units",
  "Sterile Conduits": "Sterile Conduits",
  "Supercomputers": "Supercomputers",
  "Superconductors": "Superconductors",
  "Supertensile Plastics": "Supertensile Plastics",
  "Suspended Plasma": "Suspended Plasma",
  "Synthetic Oil": "Synthetic Oil",
  "Synthetic Synapses": "Synthetic Synapses",
  "Test Cultures": "Test Cultures",
  "Toxic Metals": "Toxic Metals",
  "Transcranial Microcontrollers": "Transcranial Microcontrollers",
  "Transmitter": "Transmitter",
  "Ukomi Superconductors": "Ukomi Superconductors",
  "Vaccines": "Vaccines",
  "Viral Agent": "Viral Agent",
  "Water": "Water",
  "Water-Cooled CPU": "Water-Cooled CPU",
  "Wetware Mainframe": "Wetware Mainframe",
};

/** Resolve a PI commodity name into the requested locale. */
export function localizeProductName(name: string, locale: Locale): string {
  if (locale === "zh") return PI_NAMES_ZH[name] ?? name;
  if (locale === "ru") return PI_NAMES_RU[name] ?? name;
  return name;
}

// ── Planet types ──────────────────────────────────────────────────────────
// Canonical names from CCP static data (group 7 = Planet). The ru locale
// matches what Russian players see in their EVE client (English fallback).
export const PLANET_TYPE_NAMES_ZH: Record<string, string> = {
  Barren: "贫瘠",
  Gas: "气态",
  Ice: "冰体",
  Lava: "熔岩",
  Oceanic: "海洋",
  Plasma: "等离子",
  Storm: "风暴",
  Temperate: "温和",
};

export const PLANET_TYPE_NAMES_RU: Record<string, string> = {
  Barren: "Barren",
  Gas: "Gas",
  Ice: "Ice",
  Lava: "Lava",
  Oceanic: "Oceanic",
  Plasma: "Plasma",
  Storm: "Storm",
  Temperate: "Temperate",
};

export function localizePlanetType(type: string, locale: Locale): string {
  if (locale === "zh") return PLANET_TYPE_NAMES_ZH[type] ?? type;
  if (locale === "ru") return PLANET_TYPE_NAMES_RU[type] ?? type;
  return type;
}

// ── Hauler ships ──────────────────────────────────────────────────────────
// Canonical names from CCP static data (Epithal=655, Squall=81008,
// Deluge=81046, Torrent=81047).
export const HAULER_NAMES_ZH: Record<string, string> = {
  Epithal: "埃比斯级",
  Squall: "狂风级",
  Deluge: "洪水级",
  Torrent: "湍流级",
};

export const HAULER_NAMES_RU: Record<string, string> = {
  Epithal: "Epithal",
  Squall: "Squall",
  Deluge: "Deluge",
  Torrent: "Torrent",
};

export function localizeHaulerName(ship: string, locale: Locale): string {
  if (locale === "zh") return HAULER_NAMES_ZH[ship] ?? ship;
  if (locale === "ru") return HAULER_NAMES_RU[ship] ?? ship;
  return ship;
}

// ── Sell strategy options ─────────────────────────────────────────────────
// These are app-defined enum strings, not CCP data. Hand-curated per locale.
export const SELL_STRATEGY_LABELS: Record<Locale, Record<string, string>> = {
  en: {
    to_buy_order: "to buy order",
    at_median: "at median",
    at_sell_order: "at sell order",
  },
  zh: {
    to_buy_order: "卖给收购单",
    at_median: "按中位价挂卖",
    at_sell_order: "按出售单价挂卖",
  },
  ru: {
    to_buy_order: "по ордеру на покупку",
    at_median: "по медиане",
    at_sell_order: "по ордеру на продажу",
  },
};

export function localizeSellStrategy(strategy: string, locale: Locale): string {
  return SELL_STRATEGY_LABELS[locale][strategy] ?? strategy;
}

// ── Solver / job status ──────────────────────────────────────────────
// PuLP solver status (returned in OptimizationResult.status) and our internal
// in-process job state. Match against canonical English values defensively;
// unknown statuses fall through to the raw string.
export const SOLVER_STATUS_LABELS: Record<Locale, Record<string, string>> = {
  en: {
    Optimal: "Optimal",
    "Not Solved": "Not Solved",
    Infeasible: "Infeasible",
    Unbounded: "Unbounded",
    Undefined: "Undefined",
  },
  zh: {
    Optimal: "最优",
    "Not Solved": "未求解",
    Infeasible: "无可行解",
    Unbounded: "无界",
    Undefined: "未定义",
  },
  ru: {
    Optimal: "Оптимально",
    "Not Solved": "Не решено",
    Infeasible: "Невыполнимо",
    Unbounded: "Неограничено",
    Undefined: "Не определено",
  },
};

export function localizeSolverStatus(status: string, locale: Locale): string {
  return SOLVER_STATUS_LABELS[locale][status] ?? status;
}

export const JOB_STATUS_LABELS: Record<Locale, Record<string, string>> = {
  en: {
    queued: "queued",
    running: "running",
    succeeded: "succeeded",
    failed: "failed",
  },
  zh: {
    queued: "排队中",
    running: "运行中",
    succeeded: "已完成",
    failed: "失败",
  },
  ru: {
    queued: "в очереди",
    running: "выполняется",
    succeeded: "успешно",
    failed: "неудачно",
  },
};

export function localizeJobStatus(status: string, locale: Locale): string {
  return JOB_STATUS_LABELS[locale][status] ?? status;
}
